// 通常（フルスクリーン）プレイヤーの種別。アナリティクスログとvideo.jsコントロールバー構成の切替に使う
export const FULL_PLAYER_TYPE = 'full';
// 累積再生時間をアナリティクスへ送信する閾値（ミリ秒）
export const PLAY_MSEC_SEND_THRES = 5000;
